import { useNavigate } from "react-router-dom";
import { FileX2, UploadCloud, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function NotEligible({ eligibility }) {
  const navigate = useNavigate();
  const motivo = eligibility?.motivo ||
    "Questo documento non può essere analizzato da OKKIO.";

  return (
    <div className="min-h-screen bg-[#F7F9FC]" data-testid="not-eligible-screen">
      <header className="max-w-2xl mx-auto px-5 py-4 flex items-center justify-between">
        <button onClick={() => navigate("/")} data-testid="nav-logo" className="flex items-center"><Logo className="text-2xl" /></button>
        <button onClick={() => navigate("/")} data-testid="back-home"
          className="inline-flex items-center gap-1.5 rounded-full border border-[#E2E8F0] bg-white px-4 h-10 text-sm font-semibold text-[#334155] hover:border-[#3157F6] hover:text-[#3157F6] transition-colors">
          <ArrowLeft className="w-4 h-4" strokeWidth={2} /> Torna alla Home
        </button>
      </header>

      <main className="max-w-2xl mx-auto px-5 pt-10 pb-16">
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8 text-center">
          <span className="w-16 h-16 rounded-2xl bg-[#DC3F4C]/10 flex items-center justify-center mx-auto mb-5">
            <FileX2 className="w-8 h-8 text-[#DC3F4C]" strokeWidth={1.9} />
          </span>
          <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-[#0F172A]">
            Questo documento non è idoneo all'analisi
          </h1>
          <p className="mt-4 text-[#475569] leading-relaxed" data-testid="not-eligible-reason">
            {motivo}
          </p>
          <div className="mt-5 rounded-xl bg-[#F7F9FC] border border-[#E2E8F0] p-4 text-sm text-[#64748B] leading-relaxed">
            Il controllo di idoneità è <span className="font-semibold text-[#0F172A]">gratuito</span>:
            non ti è stato addebitato nulla e non è previsto alcun pagamento per questo documento.
          </div>

          <Button data-testid="upload-another" onClick={() => navigate("/controlla-preventivo")}
            className="mt-7 w-full sm:w-auto rounded-xl h-14 px-8 text-base font-semibold bg-[#3157F6] hover:bg-[#2444D8] text-white active:scale-[0.98] transition-transform">
            <UploadCloud className="w-5 h-5 mr-2" strokeWidth={2} /> Carica un altro preventivo
          </Button>
        </div>

        <p className="mt-6 text-center text-sm text-[#64748B]">
          OKKIO analizza <span className="font-semibold text-[#334155]">preventivi di ristrutturazione privata</span> con prezzi e voci leggibili.
        </p>
      </main>
    </div>
  );
}
